import { Directive, Input } from "@angular/core";

@Directive({
    selector: 'create-role-feature'
})
export class CreateRoleFeature {
    @Input()
    text: string = '';
}